export const JSON_Bank_Check_Status4 = {
    "code":"0x0200",
    "message":"Record fetched successfully.",
    "status":"SUCCESS",
    "data":{
        "requestId":"VPAN28335017105332100010",
        "currentStatus":"FOUND",
        "response":{
            "pan":"ABCDE1234F",
            "type":"Individual",
            "firstName":"Amit",
            "lastName":"Gupta",
            "middleName":"",
            "fullName":"Amit Gupta"
        }
    }
};

export const JSON_Bank_Check_Status5 = {
    "code":"0x0200",
    "message":"Record fetched successfully.",
    "status":"SUCCESS",
    "data":{
        "requestId":"VPAN28335017105332100010",
        "currentStatus":"NOT_FOUND"
    }
}

export const JSON_Bank_Check_Status6 = {
    "code": "0x0202",
    "status": "FAILURE",
    "message": "Failure",
    "data":{
            "requestId":"VVPA28311712855182658FAE",
            "currentStatus":"FAILED"
        }
    
}
